import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { DescripcionContenidoPaqueteList } from "./components/contenidospaquetes/list"

type Entity = models.DescripcionPaqueteDTO;
export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void>;
    onGuardar: () => Promise<void>;
    nuevo: boolean;
}

/**
* Componente para editar un Entity
*/
export class DescripcionPaqueteFormNoRx extends React.PureComponent<Props> {
    errors = () => validation.getErrors(this.rules, this.props.value);
    getField = formfields(() => this.props, this.errors);

    get rules(): validation.Rules<Entity> {
        return {};
    }

    render() {
        const { value, onGuardar, nuevo } = this.props;
        const getField = this.getField;

        const Text = getField(kea.Text);
        const Check = getField(kea.Checkbox);
        const Number = getField(kea.Number);
        const ContenidoPaquetes = getField(DescripcionContenidoPaqueteList);
        const CpSatTipoEmbalajeSelector = getField( selectores.CpSatTipoEmbalajeSelector);

        return (
            <div>
                <kea.Title titulo="Descripción Paquete" onRegresar={() => history.go("/catalogos/DescripcionPaquete")} />
                {kea.autogrid(6, [
                    <Text field="Nombre" />,
                    <Check field="VisibleClientesRelacionados" label="Visible solo para clientes relacionados" />,
                    <Number field="Peso" label="Peso en Kg default" />,
                    <Number field="Largo" label="Largo en cm default" />,
                    <Number field="Alto" label="Alto en cm default" />,
                    <Number field="Ancho" label="Ancho en cm default" />,
                    <Check field="VerSoloContenidosPaquetesRelacionados" label="Ver Solo Contenidos Paquetes Relacionados" />,
                    <CpSatTipoEmbalajeSelector field="IdTipoEmbalaje" label="Tipo embalaje" />
                ])}
                <ContenidoPaquetes field="ContenidosPaquetes" idDescripcionPaquete={value.IdRegistro} />

                <div className="row">
                    <div className="col-md-12">
                        <kea.GuardarButton onClick={onGuardar} disabled={validation.hasError(this.errors())} />
                    </div>
                </div>
            </div>);
    }
}

export const DescripcionPaqueteForm = componentToRx(DescripcionPaqueteFormNoRx);


// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/descripcionespaquete/edit/form.tsx